import React from "react";
import "./AdActivity.css";

function AdActivity(){
    return <div className="adactivity">AdActivity</div>;
}

export default AdActivity;